import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";

type PropsDef = {
  isOpen: boolean;
  programName: string;
  onClose: () => void;
};

export default function RefundConfirmationModal(props: PropsDef) {
  const { isOpen, programName, onClose } = props;
  const { t } = useTranslation();

  return (
    <ModalLayout isOpen={isOpen} classNames={`${styles.modal}`}>
      <div className={styles.confirmation_modal_content}>
        <div className={styles.close_button} onClick={onClose}>
          <i className="ico ico-x" />
        </div>
        <div className={styles.title_and_content}>
          <div className={styles.title}>
            <i className={`ico ico-dollar ${styles.info}`} />
            <h2>{t("Refunds will be sent through Stripe")}</h2>
          </div>
          <div className={styles.content}>
            <Trans
              i18nKey="refund_message_with_program"
              values={{ programName }}
              components={{ strong: <strong /> }}
            />
          </div>
          <div className={styles.button}>
            <button onClick={onClose} className={`${styles.confirm_button} btn btn-primary`}>
              {t("Ok")}
            </button>
          </div>
        </div>
      </div>
    </ModalLayout>
  );
}
